import React from 'react';
import Marquee from 'react-fast-marquee';

export const mentorCompanies = [
  { name: 'Project44', logo: '/project_44_logo.png' },
  { name: 'Condé Nast', logo: '/conde_nast_logo.jpeg' },
  { name: 'Tesco', logo: '/tesco.jpeg' },
  { name: 'Saltmine', logo: '/saltmine.svg' },
  { name: 'Livspace', logo: '/livspace.svg' },
  { name: 'Kuliza', logo: '/kuliza.jpg' },
  { name: 'Kony', logo: '/kony.png' }
];

const CompanyStrip = () => (
  <section className="company-strip" aria-label="Companies our mentors have worked at">
    <div className="company-strip-head">
      <span className="company-strip-line" aria-hidden="true" />
      <p>
        Learn from engineers who have built products at{' '}
        <span className="text-gradient">top companies</span>
      </p>
      <span className="company-strip-line" aria-hidden="true" />
    </div>

    <div className="company-strip-track">
      <Marquee speed={36} pauseOnHover autoFill>
        {mentorCompanies.map((c) => (
          <div className="company-card" key={c.name}>
            <span className="company-card-logo">
              <img src={c.logo} alt="" loading="lazy" />
            </span>
            <span className="company-card-name">{c.name}</span>
          </div>
        ))}
      </Marquee>
    </div>
  </section>
);

export default CompanyStrip;
